"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureQueryParameter = void 0;
var _updateQueryParameters = require("./updateQueryParameters");
/**
 * Ensures that there is query parameter by provided name and value in browser URL
 */
const ensureQueryParameter = (name, value) => {
  const queryParams = new URLSearchParams(window.location.search);

  // There is no need to update or add new parameter so skipping
  if (queryParams.has(name) && queryParams.get(name) === value) {
    return;
  }
  queryParams.set(name, value);
  (0, _updateQueryParameters.updateQueryParameters)(queryParams);
};
exports.ensureQueryParameter = ensureQueryParameter;
